module.exports = __webpack_public_path__ + "static/media/hk_logo_full.6978f3d2.jpg";